import { inject, Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, of, switchMap, take, catchError } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';


@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {

  private authService = inject(AuthService);
  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.isAuthenticated$.pipe(
      take(1),
      switchMap(isAuthenticated => {
        if (!isAuthenticated) {
          return next.handle(request);
        }

        return this.authService.getAccessTokenSilently().pipe(
          take(1),
          catchError(() => of(null)),
          switchMap(token => {
            const cloned = token
              ? request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
              : request;
            return next.handle(cloned);
          })
        );
      })
    );
  }
}
